import {ServiceStatus} from "@/enums/ServiceStatus";
import firebase from "firebase";
import {NotificationTypeEnum} from "@/enums/NotificationTypeEnum";
import router from "@/router";
import { PremiumServiceEventTypeEnum, PremiumServiceProductTypeEnum, PremiumServiceRequestTypeEnum } from "@/enums/PremiumServiceEventTypes";
export default {
  name: "DeleteServiceDialog",
  data() {
    return {
      dialog: false,
      reject: null,
      message: null,
      outputMsg: "",
      title: null,
      resolve: null,
      hasTextField: false,
      textFieldLabel: "Note",
      isAgree: false,
      isSuccess: false,
      thanksMessage: "",
      errorMessage: "",
      loadingMessage: "",
      loading: false,
      serviceId: "",
      options: {
        color: "#3f51b5",
        width: 605,
        zIndex: 200,
        noconfirm: false
      }
    }
  },
  props: {
    additionalService: {
      type: Object
    }
  },
  computed: {
    currentFacility() {
      return this.$store.state.authModule.currentFacility;
    },
    currentFacilityData() {
      return this.$store.state.authModule.currentFacilityData;
    }
  },
  methods: {
    open(title, message, hasTextField, textFieldLabel, options, thanksMessage, errorMessage, loadingMessage, serviceId) {
      this.dialog = true;
      this.title = title;
      this.hasTextField = hasTextField;
      this.textFieldLabel = textFieldLabel;
      this.message = message;
      this.thanksMessage = thanksMessage;
      this.errorMessage = errorMessage;
      this.loadingMessage = loadingMessage;
      this.options = Object.assign(this.options, options);
      this.serviceId = serviceId;
      console.log(serviceId)
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.isAgree = true;
      this.isSuccess = true;
      this.resolve({ agree: true, message: this.outputMsg });
    },

    error() {
      this.isSuccess = false;
    },

    cancel() {
      this.resolve(false);
      this.dialog = false;
      this.isAgree = false;
    },

    load() {
      this.loading = true;
    },

    async deleteService() {
      this.loading = true;

      let requests = this.$store.state.additionalServicesModule.serviceRequestByServiceId;
      requests = requests.filter(x => x.status === (ServiceStatus.AwaitingApproval || ServiceStatus.Approved))

      for(let i = 0; i < requests.length; i++) {
          console.log(requests[i])

          let title, body = ``
  
          const eventTypes = Object.values(PremiumServiceEventTypeEnum)
          const requestTypes = Object.values(PremiumServiceRequestTypeEnum)
          const productTypes = Object.values(PremiumServiceProductTypeEnum)
    
          if(eventTypes.includes(requests[i].serviceItemType) || requestTypes.includes(requests[i].serviceItemType)){
            title = `Booking for ${requests[i].serviceName} has been cancelled`
            body = `Your booking for ${requests[i].serviceName} could not be completed as it is no longer available. You can book another service here.`
          }
          else if (productTypes.includes(requests[i].serviceItemType)){
            title = `Order for ${requests[i].serviceName} has been cancelled`
            body = `Your order for ${requests[i].serviceName} could not be completed as it is no longer available. You can book another service here.`
          }

          let emailTitle, emailBody = ``
  
          if(eventTypes.includes(requests[i].serviceItemType)){
            emailTitle = `The concierge event ${requests[i].serviceName} has been deleted`
            emailBody = `The concierge event <b>${requests[i].serviceName}</b> for <b>${requests[i].residentName}</b> in <b>${this.currentFacilityData.name}</b> was cancelled. A refund might be required `
          }
          else if (requestTypes.includes(requests[i].serviceItemType)){
            emailTitle = `The concierge request ${requests[i].serviceName} has been deleted`;
            emailBody = `The concierge request <b>${requests[i].serviceName}</b> for <b>${requests[i].residentName}</b> in <b>${this.currentFacilityData.name}</b> was cancelled. A refund might be required`
          }
          else if (productTypes.includes(requests[i].serviceItemType)){
            emailTitle = `The product ${requests[i].serviceName} has been deleted`
            emailBody = `The product <b>${requests[i].serviceName}</b> for <b>${requests[i].residentName}</b> in <b>${this.currentFacilityData.name}</b> was cancelled. A refund might be required `
          }

        if(requests[i].bookByFamilyId) {
          await firebase
            .firestore()
            .collection("notifications")
            .add({
              to: 'family',
              facilityId: this.currentFacility,
              residentId: requests[i].residentId,
              referenceId: requests[i].id,
              type: NotificationTypeEnum.ServiceRequestStatusChanged,
              familyHubUserId: requests[i].bookByFamilyId,
              title: title,
              body: body,
              unread: true,
              dateTimeCreated: firebase.firestore.Timestamp.fromDate(new Date()),
              dateTimeUpdated: firebase.firestore.Timestamp.fromDate(new Date()),
            }).then(() => {
            console.log("Success send to family")
          })
        }

        if(!requests[i].bookByFamilyId && !requests[i].bookByStaffEmail) {
          await firebase
            .firestore()
            .collection("notifications")
            .add({
              to: 'resident',
              facilityId: this.currentFacility,
              residentId: requests[i].residentId,
              referenceId: requests[i].id,
              description: '',
              unread: true,
              type: NotificationTypeEnum.ServiceRequestStatusChanged,
              title: title,
              body: body,
              dateTimeCreated: firebase.firestore.Timestamp.fromDate(new Date()),
              dateTimeUpdated: firebase.firestore.Timestamp.fromDate(new Date()),
            }).then(() => {
            console.log("Success send to resident")
          })
        }

        await firebase
          .firestore()
          .collection('email')
          .add({
            to:  "support@getreshub.com",
            facilityId: this.currentFacility,
            message: {
              subject: emailTitle,
              html: emailBody
            }
          }).then(() => {
          console.log("SEN EMAIL SUCCESS")
        })
      }

      await this.$store.dispatch("deleteAdditionalService", { additionalServiceId: this.serviceId }).then(() => {
        history.back();
      });

      await this.$store.dispatch("getAdditionalServiceRequests", []);

      this.loading = false;
    }
  }
}